import { AbstractPlugin as g } from "./ghl-ui.es794.js";
const n = Symbol("onInitialize"), o = Symbol("onDestroy"), a = Symbol("announceEvent"), s = Symbol("announceMessage"), l = "aria-relevant", d = "aria-atomic", c = "aria-live", h = "role", u = {
  expire: 7e3
};
class y extends g {
  constructor(e) {
    super(e), this.options = {
      ...u,
      ...this.getOptions()
    }, this.originalTriggerMethod = this.draggable.trigger, this[n] = this[n].bind(this), this[o] = this[o].bind(this);
  }
  attach() {
    this.draggable.on("draggable:initialize", this[n]);
  }
  detach() {
    this.draggable.off("draggable:destroy", this[o]);
  }
  getOptions() {
    return this.draggable.options.announcements || {};
  }
  [a](e) {
    const i = this.options[e.type];
    i && typeof i == "string" && this[s](i), i && typeof i == "function" && this[s](i(e));
  }
  [s](e) {
    p(e, {
      expire: this.options.expire
    });
  }
  [n]() {
    this.draggable.trigger = (e) => {
      try {
        this[a](e);
      } finally {
        this.originalTriggerMethod.call(this.draggable, e);
      }
    };
  }
  [o]() {
    this.draggable.trigger = this.originalTriggerMethod;
  }
}
const r = b();
function p(t, {
  expire: e
}) {
  const i = document.createElement("div");
  return i.textContent = t, r.appendChild(i), setTimeout(() => {
    r.removeChild(i);
  }, e);
}
function b() {
  const t = document.createElement("div");
  return t.setAttribute("id", "draggable-live-region"), t.setAttribute(l, "additions"), t.setAttribute(d, "true"), t.setAttribute(c, "assertive"), t.setAttribute(h, "log"), t.style.position = "fixed", t.style.width = "1px", t.style.height = "1px", t.style.top = "-1px", t.style.overflow = "hidden", t;
}
document.addEventListener("DOMContentLoaded", () => {
  document.body.appendChild(r);
});
export {
  y as default,
  u as defaultOptions
};
